import { useTranslation } from 'react-i18next';

const useGetTabOptions = () => {
  const { t } = useTranslation('host-brief');
  return [
    { type: 'talking-point', label: t('talking_point') },
    { type: 'giveaway', label: t('giveaway.title') },
    { type: 'promo', label: t('promo') },
  ];
};

export default useGetTabOptions;
